import { Injectable } from "@angular/core";
import { CanActivate, CanLoad } from "@angular/router";

// AuthGuard is wired to the `/auth/*` parent route in app-routing.module
// (NOT /main -- that is gated by CanActivateGuard). Its only historical job
// was to bounce already-signed-in Duende users away from /auth screens; for
// Cognito users `getIdentityClaims()` is always null, so the guard was a
// permissive no-op in practice.
//
// Post-Stage 5, /main protection lives in CanActivateGuard, which already
// checks `getCurrentUser()` (Cognito) before falling back to Duende. Signing
// out via Amplify `signOut()` (user-menu / sidenav) clears the Cognito
// session, and CanActivateGuard then denies access to /main -- so we do NOT
// need a session check here. A session check here actively *breaks* /auth
// access (infinite redirect to /auth/sign-in for unauthenticated
// users who are trying to reach the sign-in page).
@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate, CanLoad {
    canActivate(): boolean {
        return true;
    }
    canLoad(): boolean {
        return true;
    }
}
